import { useEffect, useState } from "react";
import api from "../../../lib/api";
import { Mail, Trash2, Check } from "lucide-react";

export default function MessagesInbox() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/messages").then(({ data }) => setItems(data));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const markRead = async (id) => {
    await api.put(`/messages/${id}/read`);
    load();
  };
  const remove = async (id) => {
    if (!window.confirm("Supprimer ce message ?")) return;
    await api.delete(`/messages/${id}`);
    setOpen(null);
    load();
  };

  return (
    <div data-testid="messages-inbox">
      <div className="mb-8">
        <h1 className="font-serif text-4xl">Messages reçus</h1>
        <p className="text-[#4A3F35] mt-2">{items.length} message{items.length > 1 ? "s" : ""} au total · {items.filter((m) => !m.read).length} non lu{items.filter((m) => !m.read).length > 1 ? "s" : ""}</p>
      </div>

      {items.length === 0 ? (
        <div className="bg-[#FDFBF7] rounded-2xl border border-[#2D2A26]/10 p-16 text-center text-[#4A3F35]/60">
          <Mail className="mx-auto mb-4 text-[#4A3F35]/30" size={40} />
          Aucun message pour le moment.
        </div>
      ) : (
        <div className="bg-[#FDFBF7] rounded-2xl border border-[#2D2A26]/10 overflow-hidden divide-y divide-[#2D2A26]/10">
          {items.map((m) => (
            <button
              key={m.id}
              onClick={() => { setOpen(m); if (!m.read) markRead(m.id); }}
              className="w-full text-left p-5 hover:bg-[#F6F3EC] transition flex gap-4 items-start"
              data-testid={`message-${m.id}`}
            >
              <div className={`w-2 h-2 rounded-full mt-2 ${m.read ? "bg-transparent" : "bg-[#C87A5E]"}`} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3">
                  <span className={`${m.read ? "" : "font-semibold"}`}>{m.name}</span>
                  <span className="text-xs text-[#4A3F35]/50">{new Date(m.created_at).toLocaleString("fr-FR")}</span>
                  {m.service && <span className="text-xs bg-[#C87A5E]/10 text-[#C87A5E] px-2 py-0.5 rounded-full">{m.service}</span>}
                </div>
                <div className="text-sm text-[#4A3F35] mt-1 truncate">{m.message}</div>
              </div>
            </button>
          ))}
        </div>
      )}

      {open && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-6" onClick={() => setOpen(null)}>
          <div className="bg-[#FDFBF7] rounded-3xl p-8 w-full max-w-xl max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="message-detail">
            <div className="flex items-start justify-between gap-4 mb-6">
              <div>
                <h3 className="font-serif text-2xl">{open.name}</h3>
                <a href={`mailto:${open.email}`} className="text-[#C87A5E] link-underline text-sm">{open.email}</a>
                {open.phone && <div className="text-sm text-[#4A3F35]/70 mt-1">{open.phone}</div>}
              </div>
              <button onClick={() => remove(open.id)} className="text-red-700 link-underline text-sm flex items-center gap-1">
                <Trash2 size={14} /> Supprimer
              </button>
            </div>
            {open.service && (
              <div className="mb-4"><span className="overline">Service</span><div>{open.service}</div></div>
            )}
            <div className="overline mb-2">Message</div>
            <p className="bg-[#F6F3EC] rounded-xl p-4 leading-relaxed whitespace-pre-line">{open.message}</p>
            <div className="text-xs text-[#4A3F35]/50 mt-4">Reçu le {new Date(open.created_at).toLocaleString("fr-FR")}</div>
          </div>
        </div>
      )}
    </div>
  );
}
